import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate } from "react-router-dom";
import Coding from "./Coding";
import Art from "./Art";
import Other from "./Other";
import "./App.css";
import ArtCard from "./ArtCard";
import cards from "./data/cardData";

import { NavContext } from "./components/NavContext";
import LoadingScreen from "./components/LoadingScreen";

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

function AppContent() {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [doorState, setDoorState] = useState("open");


  const handleNav = (to) => (e) => {
  e.preventDefault();
  setIsLoading(true);
  setDoorState("open"); // doors start open (off-screen)
  setTimeout(() => {
    setDoorState("closed"); // doors slide in (cover page)
    setTimeout(() => {
      navigate(to);
      setDoorState("open"); // doors slide out (reveal new page)
      setTimeout(() => setIsLoading(false), 700);
    }, 700); // match your door close duration
  }, 10); // allow a tick for the doors to render open before closing
};

  return (
    <NavContext.Provider value={handleNav}>
      {isLoading && <LoadingScreen doorState={doorState} />}
      <Routes>
        {/* Main Landing Page */}
        <Route
        path="/"
        element={
          <div className="relative min-h-screen overflow-hidden">
            <div
              className="absolute inset-0 pointer-events-none"
              style={{
                backgroundImage: "url('/assets/Card/bg.png')",
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                transformOrigin: "center",
                imageRendering: "pixelated"
              }}
            />
            <div className="relative flex flex-col items-center justify-center min-h-screen text-center">
              <h1 className="text-5xl font-bold mb-4 text-pink-300">Laksh Pandya</h1>
              <p className="text-lg text-pink-300 mb-8">
                I code, draw a bit, stuff.
              </p>
              <div className="flex gap-8">
                {cards
                  .filter(card => card.group === "main")
                  .map(card => (
                  <a key={card.id} href={card.link} onClick={handleNav(card.link)}><ArtCard {...card} />
                  </a>  
                  ))}
              </div>
            </div>
          </div>
        }
      />
        {/* Subpages */}
        <Route path="/coding" element={<Coding />} />
        <Route path="/art" element={<Art />} />
        <Route path="/other" element={<Other />} />
      </Routes>
    </NavContext.Provider>
  );
}

export default App;
